export default __webpack_public_path__ + "static/media/pricedown.6bea83af.otf";